(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function openMenuDrawer() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) return;
    var summary = details.querySelector('summary');
    if (summary && typeof summary.click === 'function') {
      if (!details.open) summary.click();
    }
  }

  function openSearch(nav) {
    function tryOpen() {
      var m = document.getElementById('search-modal');
      if (m && typeof m.showDialog === 'function') {
        m.showDialog();
        return true;
      }
      return false;
    }
    if (tryOpen()) return;
    customElements.whenDefined('dialog-component').then(function () {
      if (!tryOpen()) {
        var url = nav && nav.getAttribute('data-search-url');
        window.location.href = url || '/search';
      }
    });
  }

  function openCart(nav) {
    var useDrawer = nav.getAttribute('data-cart-drawer') === 'true';
    if (!useDrawer) {
      window.location.href = nav.getAttribute('data-cart-url') || '/cart';
      return;
    }
    function tryOpen() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return true;
      }
      return false;
    }
    if (tryOpen()) return;
    customElements.whenDefined('cart-drawer-component').then(function () {
      if (!tryOpen()) {
        window.location.href = nav.getAttribute('data-cart-url') || '/cart';
      }
    });
  }

  onReady(function () {
    var nav = document.getElementById('zoony-mobile-bottom-bar');
    if (!nav) return;

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-zoony-mnav-action]');
      if (!btn || !nav.contains(btn)) return;
      var action = btn.getAttribute('data-zoony-mnav-action');
      if (action === 'menu') {
        e.preventDefault();
        openMenuDrawer();
      } else if (action === 'search') {
        e.preventDefault();
        openSearch(nav);
      } else if (action === 'cart') {
        e.preventDefault();
        openCart(nav);
      }
    });
  });
})();
